import { useEffect, useRef } from 'react';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
export var useUserPreferencesInitListener = function useUserPreferencesInitListener(isInitialized, resolvedUserPreferences, api) {
  var isInitializedRef = useRef(false);
  useEffect(function () {
    if (isInitialized && resolvedUserPreferences && !isInitializedRef.current) {
      var _api$analytics;
      isInitializedRef.current = true;
      api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.fireAnalyticsEvent({
        action: ACTION.INITIALISED,
        actionSubject: ACTION_SUBJECT.USER_PREFERENCES,
        actionSubjectId: ACTION_SUBJECT_ID.SELECTION_TOOLBAR_PREFERENCES,
        attributes: {
          toolbarDocking: resolvedUserPreferences.toolbarDockingPosition
        },
        eventType: EVENT_TYPE.OPERATIONAL
      });
    }
  }, [api, isInitialized, resolvedUserPreferences]);
};